import { useSlots as It, reactive as Vt, ref as d, computed as u, watch as _, watchEffect as Ot, nextTick as g, onMounted as wt } from "vue";
import { useResizeObserver as D } from "./index562.js";
import { scrollIntoView as Ct } from "./index704.js";
import { useLocale as yt } from "./index597.js";
import { useId as Et } from "./index640.js";
import { useNamespace as we } from "./index559.js";
import { useFormItem as _t, useFormItemInputId as Dt } from "./index585.js";
import { useEmptyValues as Tt } from "./index583.js";
import { useComposition as St } from "./index710.js";
import { useFormDisabled as Ft, useFormSize as Mt } from "./index586.js";
import { useFocusController as Rt } from "./index587.js";
import { debugWarn as Ce } from "./index588.js";
import { isArray as H, isFunction as A, isPlainObject as Lt, isObject as ye } from "./index575.js";
import { ValidateComponentsMap as Wt } from "./index606.js";
import { isEmpty as Nt, isUndefined as B, isNumber as kt } from "./index565.js";
import { MINIMUM_INPUT_WIDTH as zt } from "./index696.js";
import { getEventCode as Ee } from "./index589.js";
import { EVENT_CODE as m } from "./index590.js";
import { UPDATE_MODEL_EVENT as T, CHANGE_EVENT as Pt } from "./index584.js";
import S from "./index764.js";
import { isIOS as _e, isClient as Ht, useDebounceFn as At } from "./index599.js";
import K from "./index712.js";
import Q from "./index703.js";
import Bt from "./index567.js";
import Kt from "./index796.js";
import Qt from "./index803.js";
const bl = (t, v) => {
  const { t: F } = yt(), De = It(), Te = Et(), U = we("select"), Se = we("input"), n = Vt({
    inputValue: "",
    options: /* @__PURE__ */ new Map(),
    cachedOptions: /* @__PURE__ */ new Map(),
    optionValues: [],
    // sorted value of options
    selected: [],
    selectionWidth: 0,
    collapseItemWidth: 0,
    selectedLabel: "",
    hoveringIndex: -1,
    previousQuery: null,
    inputHovering: !1,
    menuVisibleOnFocus: !1,
    isBeforeHide: !1
  }), Fe = d(), V = d(), x = d(), j = d(), O = d(), Me = d(), te = d(), le = d(), ne = d(), M = d(), q = d(), o = d(!1), I = d(), $ = d(!1), { form: ae, formItem: h } = _t(), { inputId: Re } = Dt(t, {
    formItemContext: h
  }), { valueOnClear: Le, isEmptyValue: We } = Tt(t), {
    isComposing: G,
    handleCompositionStart: Ne,
    handleCompositionUpdate: ke,
    handleCompositionEnd: ze
  } = St({
    afterComposition: (e) => ve(e)
  }), w = Ft(), { wrapperRef: ie, isFocused: J, handleBlur: Pe } = Rt(O, {
    disabled: w,
    afterFocus() {
      t.automaticDropdown && !o.value && (o.value = !0, n.menuVisibleOnFocus = !0);
    },
    beforeBlur(e) {
      var l, a;
      return ((l = x.value) == null ? void 0 : l.isFocusInsideContent(e)) || ((a = j.value) == null ? void 0 : a.isFocusInsideContent(e));
    },
    afterBlur() {
      var e;
      o.value = !1, n.menuVisibleOnFocus = !1, t.validateEvent && ((e = h?.validate) == null || e.call(h, "blur").catch((l) => Ce(l)));
    }
  }), X = u(() => H(t.modelValue) ? t.modelValue.length > 0 : !We(t.modelValue)), He = u(() => {
    var e;
    return (e = ae?.statusIcon) != null ? e : !1;
  }), Ae = u(() => t.clearable && !w.value && X.value && (J.value || n.inputHovering)), oe = u(
    () => t.remote && t.filterable && !t.remoteShowSuffix ? "" : t.suffixIcon
  ), Be = u(
    () => U.is("reverse", !!(oe.value && o.value))
  ), Y = u(() => h?.validateState || ""), Ke = u(
    () => Y.value && Wt[Y.value]
  ), Qe = u(() => t.remote ? t.debounce : 0), Ue = u(
    () => t.remote && !n.inputValue && n.options.size === 0
  ), je = u(() => t.loading ? t.loadingText || F("el.select.loading") : t.filterable && n.inputValue && n.options.size > 0 && C.value === 0 ? t.noMatchText || F("el.select.noMatch") : n.options.size === 0 ? t.noDataText || F("el.select.noData") : null), C = u(
    () => r.value.filter((e) => e.visible).length
  ), r = u(() => {
    const e = Array.from(n.options.values()), l = [];
    return n.optionValues.forEach((a) => {
      const i = e.findIndex((s) => s.value === a);
      i > -1 && l.push(e[i]);
    }), l.length >= e.length ? l : e;
  }), qe = u(
    () => Array.from(n.cachedOptions.values())
  ), $e = u(() => {
    const e = r.value.filter((l) => !l.created).some((l) => l.currentLabel === n.inputValue);
    return t.filterable && t.allowCreate && n.inputValue !== "" && !e;
  }), ue = () => {
    t.filterable && A(t.filterMethod) || t.filterable && t.remote && A(t.remoteMethod) || r.value.forEach((e) => {
      var l;
      (l = e.updateOption) == null || l.call(e, n.inputValue);
    });
  }, se = Mt(), Ge = u(
    () => ["small"].includes(se.value) ? "small" : "default"
  ), re = u({
    get() {
      return o.value && (t.loading || !Ue.value || t.remote && !!De.empty) && (!$.value || !Nt(n.previousQuery));
    },
    set(e) {
      o.value = e;
    }
  }), Je = u(() => {
    if (t.multiple && !B(t.modelValue))
      return S(t.modelValue).length === 0 && !n.inputValue;
    const e = H(t.modelValue) ? t.modelValue[0] : t.modelValue;
    return t.filterable || B(e) ? !n.inputValue : !0;
  }), Xe = u(() => {
    var e;
    const l = (e = t.placeholder) != null ? e : F("el.select.placeholder");
    return t.multiple || !X.value ? l : n.selectedLabel;
  }), Ye = u(() => _e ? null : "mouseenter");
  _(
    () => t.modelValue,
    (e, l) => {
      t.multiple && t.filterable && !t.reserveKeyword && (n.inputValue = "", R("")), L(), !K(e, l) && t.validateEvent && h?.validate("change").catch((a) => Ce(a));
    },
    {
      flush: "post",
      deep: !0
    }
  ), _(
    () => o.value,
    (e) => {
      e ? R(n.inputValue) : (n.inputValue = "", n.previousQuery = null, n.isBeforeHide = !0, n.menuVisibleOnFocus = !1);
    }
  ), _(
    // fix `Array.prototype.push/splice/..` cannot trigger non-deep watcher
    // https://github.com/vuejs/vue-next/issues/2116
    () => n.options.entries(),
    () => {
      Ht && (L(), t.defaultFirstOption && (t.filterable || t.remote) && C.value && ce());
    },
    {
      flush: "post"
    }
  ), _([() => n.hoveringIndex, r], ([e]) => {
    kt(e) && e > -1 ? I.value = r.value[e] || {} : I.value = {}, r.value.forEach((l) => {
      l.hover = I.value === l;
    });
  }), Ot(() => {
    n.isBeforeHide || ue();
  });
  const R = (e) => {
    n.previousQuery === e || G.value || (n.previousQuery = e, t.filterable && A(t.filterMethod) ? t.filterMethod(e) : t.filterable && t.remote && A(t.remoteMethod) && t.remoteMethod(e), t.defaultFirstOption && (t.filterable || t.remote) && C.value ? g(ce) : g(Ze));
  }, ce = () => {
    const e = r.value.filter(
      (s) => s.visible && !s.disabled && !s.states.groupDisabled
    ), l = e.find((s) => s.created), a = e[0], i = r.value.map((s) => s.value);
    n.hoveringIndex = pe(
      i,
      l || a
    );
  }, L = () => {
    if (t.multiple)
      n.selectedLabel = "";
    else {
      const l = H(t.modelValue) ? t.modelValue[0] : t.modelValue, a = Z(l);
      n.selectedLabel = a.currentLabel, n.selected = [a];
      return;
    }
    const e = [];
    B(t.modelValue) || S(t.modelValue).forEach((l) => {
      e.push(Z(l));
    }), n.selected = e;
  }, Z = (e) => {
    let l;
    const a = Lt(e);
    for (let c = n.cachedOptions.size - 1; c >= 0; c--) {
      const f = qe.value[c];
      if (a ? Q(f.value, t.valueKey) === Q(e, t.valueKey) : f.value === e) {
        l = {
          index: r.value.filter((p) => !p.created).indexOf(f),
          value: e,
          currentLabel: f.currentLabel,
          get isDisabled() {
            return f.isDisabled;
          }
        };
        break;
      }
    }
    if (l) return l;
    const i = a ? e.label : e ?? "";
    return {
      index: -1,
      value: e,
      currentLabel: i
    };
  }, Ze = () => {
    const e = n.selected.length;
    if (e > 0) {
      const l = n.selected[e - 1];
      n.hoveringIndex = r.value.findIndex(
        (a) => N(l) === N(a)
      );
    } else
      n.hoveringIndex = -1;
  }, et = () => {
    n.selectionWidth = Number.parseFloat(
      window.getComputedStyle(V.value).width
    );
  }, tt = () => {
    n.collapseItemWidth = M.value.getBoundingClientRect().width;
  }, ee = () => {
    var e, l;
    (l = (e = x.value) == null ? void 0 : e.updatePopper) == null || l.call(e);
  }, de = () => {
    var e, l;
    (l = (e = j.value) == null ? void 0 : e.updatePopper) == null || l.call(e);
  }, fe = () => {
    n.inputValue.length > 0 && !o.value && (o.value = !0), R(n.inputValue);
  }, ve = (e) => {
    if (n.inputValue = e.target.value, t.remote)
      $.value = !0, me();
    else
      return fe();
  }, me = At(() => {
    fe(), $.value = !1;
  }, Qe), y = (e) => {
    K(t.modelValue, e) || v(Pt, e);
  }, lt = (e) => Qt(e, (l) => {
    const a = n.cachedOptions.get(l);
    return !a?.disabled && !a?.states.groupDisabled;
  }), he = (e) => {
    const l = Ee(e);
    if (t.multiple && l !== m.delete && e.target.value.length <= 0) {
      const a = S(t.modelValue).slice(), i = lt(a);
      if (i < 0) return;
      const s = a[i];
      a.splice(i, 1), v(T, a), y(a), v("remove-tag", s);
    }
  }, nt = (e, l) => {
    const a = n.selected.indexOf(l);
    if (a > -1 && !w.value) {
      const i = S(t.modelValue).slice();
      i.splice(a, 1), v(T, i), y(i), v("remove-tag", l.value);
    }
    e.stopPropagation(), W();
  }, ge = (e) => {
    e.stopPropagation();
    const l = t.multiple ? [] : Le.value;
    if (t.multiple)
      for (const a of n.selected)
        a.isDisabled && l.push(a.value);
    v(T, l), y(l), n.hoveringIndex = -1, o.value = !1, v("clear"), W();
  }, be = (e) => {
    var l;
    if (t.multiple) {
      const a = S((l = t.modelValue) != null ? l : []).slice(), i = pe(a, e);
      i > -1 ? a.splice(i, 1) : (t.multipleLimit <= 0 || a.length < t.multipleLimit) && a.push(e.value), v(T, a), y(a), e.created && R(""), t.filterable && !t.reserveKeyword && (n.inputValue = "");
    } else
      !K(t.modelValue, e.value) && v(T, e.value), y(e.value), o.value = !1;
    W(), !o.value && g(() => {
      E(e);
    });
  }, pe = (e, l) => B(l) ? -1 : ye(l.value) ? e.findIndex((a) => K(Q(a, t.valueKey), N(l))) : e.indexOf(l.value), E = (e) => {
    var l, a, i, s, c;
    const f = H(e) ? e[e.length - 1] : e;
    let b = null;
    if (!Bt(f?.value)) {
      const p = r.value.filter(
        (xt) => xt.value === f.value
      );
      p.length > 0 && (b = p[0].$el);
    }
    if (x.value && b) {
      const p = (s = (i = (a = (l = x.value) == null ? void 0 : l.popperRef) == null ? void 0 : a.contentRef) == null ? void 0 : i.querySelector) == null ? void 0 : s.call(
        i,
        `.${U.be("dropdown", "wrap")}`
      );
      p && Ct(p, b);
    }
    (c = q.value) == null || c.handleScroll();
  }, at = (e) => {
    n.options.set(e.value, e), n.cachedOptions.set(e.value, e);
  }, it = (e, l) => {
    n.options.get(e) === l && n.options.delete(e);
  }, ot = u(() => {
    var e, l;
    return (l = (e = x.value) == null ? void 0 : e.popperRef) == null ? void 0 : l.contentRef;
  }), ut = () => {
    n.isBeforeHide = !1, g(() => {
      var e;
      (e = q.value) == null || e.update(), E(n.selected);
    });
  }, W = () => {
    var e;
    (e = O.value) == null || e.focus();
  }, st = () => {
    var e;
    if (o.value) {
      o.value = !1, g(() => {
        var l;
        return (l = O.value) == null ? void 0 : l.blur();
      });
      return;
    }
    (e = O.value) == null || e.blur();
  }, rt = (e) => {
    ge(e);
  }, ct = (e) => {
    if (o.value = !1, J.value) {
      const l = new FocusEvent("blur", e);
      g(() => Pe(l));
    }
  }, xe = () => {
    n.inputValue.length > 0 ? n.inputValue = "" : o.value = !1;
  }, Ie = (e) => {
    var l;
    w.value || t.filterable && o.value && e && !((l = te.value) != null && l.contains(e.target)) || (_e && (n.inputHovering = !0), n.menuVisibleOnFocus ? n.menuVisibleOnFocus = !1 : o.value = !o.value);
  }, Ve = () => {
    if (!o.value)
      Ie();
    else {
      const e = r.value[n.hoveringIndex];
      e && !e.isDisabled && be(e);
    }
  }, N = (e) => ye(e.value) ? Q(e.value, t.valueKey) : e.value, dt = u(
    () => r.value.filter((e) => e.visible).every((e) => e.isDisabled)
  ), ft = u(() => t.multiple ? t.collapseTags ? n.selected.slice(0, t.maxCollapseTags) : n.selected : []), vt = u(() => t.multiple ? t.collapseTags ? n.selected.slice(t.maxCollapseTags) : [] : []), k = (e) => {
    if (!o.value) {
      o.value = !0;
      return;
    }
    if (!(n.options.size === 0 || C.value === 0 || G.value) && !dt.value) {
      e === "next" ? (n.hoveringIndex++, n.hoveringIndex === n.options.size && (n.hoveringIndex = 0)) : e === "prev" && (n.hoveringIndex--, n.hoveringIndex < 0 && (n.hoveringIndex = n.options.size - 1));
      const l = r.value[n.hoveringIndex];
      (l.isDisabled || !l.visible) && k(e), g(() => E(I.value));
    }
  }, Oe = (e, l, a, i) => {
    for (let s = l; s >= 0 && s < i; s += a) {
      const c = e[s];
      if (!c?.isDisabled && c?.visible)
        return s;
    }
    return null;
  }, z = (e, l) => {
    var a;
    const i = n.options.size;
    if (i === 0) return;
    const s = Kt(e, 0, i - 1), c = r.value, f = l === "up" ? -1 : 1, b = (a = Oe(c, s, f, i)) != null ? a : Oe(c, s - f, -f, i);
    b != null && (n.hoveringIndex = b, g(() => E(I.value)));
  }, mt = (e) => {
    const l = Ee(e);
    let a = !0;
    switch (l) {
      case m.up:
        k("prev");
        break;
      case m.down:
        k("next");
        break;
      case m.enter:
      case m.numpadEnter:
        G.value || Ve();
        break;
      case m.esc:
        xe();
        break;
      case m.backspace:
        a = !1, he(e);
        return;
      case m.home:
        if (!o.value) return;
        z(0, "down");
        break;
      case m.end:
        if (!o.value) return;
        z(n.options.size - 1, "up");
        break;
      case m.pageUp:
        if (!o.value) return;
        z(n.hoveringIndex - 10, "up");
        break;
      case m.pageDown:
        if (!o.value) return;
        z(n.hoveringIndex + 10, "down");
        break;
      default:
        a = !1;
        break;
    }
    a && (e.preventDefault(), e.stopPropagation());
  }, ht = () => {
    if (!V.value) return 0;
    const e = window.getComputedStyle(V.value);
    return Number.parseFloat(e.gap || "6px");
  }, gt = u(() => {
    const e = ht(), l = t.filterable ? e + zt : 0;
    return { maxWidth: `${M.value && t.maxCollapseTags === 1 ? n.selectionWidth - n.collapseItemWidth - e - l : n.selectionWidth - l}px` };
  }), bt = u(() => ({ maxWidth: `${n.selectionWidth}px` })), pt = (e) => {
    v("popup-scroll", e);
  };
  D(V, et), D(ie, ee), D(ne, de), D(M, tt);
  let P;
  return _(
    () => re.value,
    (e) => {
      e ? P = D(le, ee).stop : (P?.(), P = void 0), v("visible-change", e);
    }
  ), wt(() => {
    L();
  }), {
    inputId: Re,
    contentId: Te,
    nsSelect: U,
    nsInput: Se,
    states: n,
    isFocused: J,
    expanded: o,
    optionsArray: r,
    hoverOption: I,
    selectSize: se,
    filteredOptionsCount: C,
    updateTooltip: ee,
    updateTagTooltip: de,
    debouncedOnInputChange: me,
    onInput: ve,
    deletePrevTag: he,
    deleteTag: nt,
    deleteSelected: ge,
    handleOptionSelect: be,
    scrollToOption: E,
    hasModelValue: X,
    shouldShowPlaceholder: Je,
    currentPlaceholder: Xe,
    mouseEnterEventName: Ye,
    needStatusIcon: He,
    showClearBtn: Ae,
    iconComponent: oe,
    iconReverse: Be,
    validateState: Y,
    validateIcon: Ke,
    showNewOption: $e,
    updateOptions: ue,
    collapseTagSize: Ge,
    setSelected: L,
    selectDisabled: w,
    emptyText: je,
    handleCompositionStart: Ne,
    handleCompositionUpdate: ke,
    handleCompositionEnd: ze,
    handleKeydown: mt,
    onOptionCreate: at,
    onOptionDestroy: it,
    handleMenuEnter: ut,
    focus: W,
    blur: st,
    handleClearClick: rt,
    handleClickOutside: ct,
    handleEsc: xe,
    toggleMenu: Ie,
    selectOption: Ve,
    getValueKey: N,
    navigateOptions: k,
    dropdownMenuVisible: re,
    showTagList: ft,
    collapseTagList: vt,
    popupScroll: pt,
    getOption: Z,
    // computed style
    tagStyle: gt,
    collapseTagStyle: bt,
    // DOM ref
    popperRef: ot,
    inputRef: O,
    tooltipRef: x,
    tagTooltipRef: j,
    prefixRef: Me,
    suffixRef: te,
    selectRef: Fe,
    wrapperRef: ie,
    selectionRef: V,
    scrollbarRef: q,
    menuRef: le,
    tagMenuRef: ne,
    collapseItemRef: M
  };
};
export {
  bl as useSelect
};
